module.exports = __webpack_public_path__ + "img/vol03_cup01_cover03.42c03ca1.jpg";